import { photosReceiveGetByProfileIdReducer } from '@slices/photos/photos-receive-get-by-profile-id';

import { appCreateSlice } from '@store/rtk';

import { photosClearAllPhotosReducer } from './photos-clear-all-photos';
import { photosClearCurrentProfilePhotosReducer } from './photos-clear-current-profile-photos';
import { photosClearSelectedPhotosReducer } from './photos-clear-selected-photos';
import { photosReceiveApprovedPhotosReducer } from './photos-receive-approved-photos';
import { photosReceiveUnverifiedPhotosReducer } from './photos-receive-unverified-photos';
import { photosRemoveCurrentProfilePhotoReducer } from './photos-remove-current-profile-photo';
import { photosRemovePhotoReducer } from './photos-remove-photo';
import { photosSelectAllUnverifiedPhotosReducer } from './photos-select-all-unverified-photos';
import { photosSetSelectedPhotoReducer } from './photos-set-selected-photo';
import { photosUpdateUnverifiedPhotosReducer } from './photos-update-unverified-photos';
import { PhotosState } from './types';

export const photosDefaultState: PhotosState = {
  selectedPhotos: [],
  currentProfilePhotos: undefined,
  unverifiedPhotos: undefined,
  approvedPhotos: undefined,
};

const photosSlice = appCreateSlice({
  name: 'photos',
  initialState: photosDefaultState,
  reducers: {
    photosReceiveGetByProfileId: photosReceiveGetByProfileIdReducer,
    photosReceiveUnverifiedPhotos: photosReceiveUnverifiedPhotosReducer,
    photosReceiveApprovedPhotos: photosReceiveApprovedPhotosReducer,
    photosSetSelectedPhoto: photosSetSelectedPhotoReducer,
    photosSelectAllUnverifiedPhotos: photosSelectAllUnverifiedPhotosReducer,
    photosUpdateUnverifiedPhotos: photosUpdateUnverifiedPhotosReducer,
    photosRemoveCurrentProfilePhoto: photosRemoveCurrentProfilePhotoReducer,
    photosRemovePhoto: photosRemovePhotoReducer,
    photosClearCurrentProfilePhotos: photosClearCurrentProfilePhotosReducer,
    photosClearSelectedPhotos: photosClearSelectedPhotosReducer,
    photosClearAllPhotos: photosClearAllPhotosReducer,
  },
});

export const {
  actions: {
    photosReceiveGetByProfileId,
    photosClearCurrentProfilePhotos,
    photosRemoveCurrentProfilePhoto,
    photosSetSelectedPhoto,
    photosClearSelectedPhotos,
    photosReceiveUnverifiedPhotos,
    photosReceiveApprovedPhotos,
    photosSelectAllUnverifiedPhotos,
    photosUpdateUnverifiedPhotos,
    photosRemovePhoto,
    photosClearAllPhotos,
  },
  reducer: photosReducer,
} = photosSlice;
